// extracted by mini-css-extract-plugin
export default {"container":"styles_container__O0VzH","submit":"styles_submit__3sObu","info":"styles_info__zff5L"};